/* eslint-disable no-undef */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Menu, Dropdown, Button, Divider, Progress } from 'antd';

// eslint-disable-next-line import/no-extraneous-dependencies

import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory, Link, NavLink } from 'react-router-dom';
import DokanMenuIcons from '../icon/DokanMenuIcons';
import { ReactComponent as DokanLogo } from '../../assets/images/dokan.svg';
import DokanIcons from '../icon/DokanIcons';
import { fetchProfileData } from '../../redux/overview/profile/profileActions';
import menuItems from '../../Routes';
import DokanListIcons from '../icon/DokanListIcons';
import DokanNotification from '../notice/DokanNotification';
import { getAllPreferences } from '../../redux/preferences/Actions';

function Header({ setIsOpen, isOpen }) {
    // const { setIsOpen, isOpen } = props;
    const { vendor } = useSelector((state) => state.profile);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    // responsive mobile sidebar
    const [mobileSidebar, setMobileSidebar] = useState(false);
    const handleMobileHeader = () => {
        setMobileSidebar((prev) => !prev);
    };
    const handleHeader = () => {
        setIsOpen((prev) => !prev);
    };
    const style = {
        position: 'relative',
        color: 'red',
        backgroundColor: 'red',
        margin: '0px !important',
    };
    const history = useHistory();
    const gotoEditProfile = () => {
        history.replace('/edit-account');
    };
    const location = useLocation();
    // const [isActive, setIsActive] = useState(false);
    const activeClass = 'bg-gray-dark border-gray-dark';
    const inactiveClass = 'border-gray-dark ';
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchProfileData());
        dispatch(getAllPreferences());
    }, [dispatch]);

    const va = [1, 2, 3, 4, 5];
    const menu = (
        <Menu>
            <Menu.Item className="font-extrabold text-dark">{vendor?.store_name || ''}</Menu.Item>
            <Menu.Item className="font-normal text-tertiary">Dokan@wedevs.com</Menu.Item>
            <Divider />
            <Menu.Item className="">
                <div className="flex gap-3 items-center">
                    <div className="fill-current text-green-600">
                        <DokanIcons icon="#store" />
                    </div>
                    <div className="text-tertiary hover:text-dokan-blue">
                        <button type="button">Visit Store</button>
                    </div>
                </div>
            </Menu.Item>
            <Menu.Item>
                <div className="flex gap-3 items-center">
                    <div className="fill-current text-green-600">
                        <DokanListIcons icon="global" size={15} color="#AAA" />
                    </div>
                    <div className="text-tertiary hover:text-dokan-blue">
                        <button type="button">Visit Site</button>
                    </div>
                </div>
            </Menu.Item>
            <Menu.Item>
                <div className="flex gap-3 items-center">
                    <div className="fill-current text-green-600">
                        <DokanIcons icon="#epencil" />
                    </div>
                    <div className="text-tertiary hover:text-dokan-blue">
                        <button type="button" onClick={gotoEditProfile}>
                            Edit Account
                        </button>
                    </div>
                </div>
            </Menu.Item>
            <Menu.Item>
                <div className="flex gap-3 items-center">
                    <div className="fill-current text-green-600">
                        <DokanIcons icon="#global" />
                    </div>
                    <div className="text-tertiary hover:text-dokan-blue">
                        <button type="button">Settings</button>
                    </div>
                </div>
            </Menu.Item>
            <Menu.Item>
                <div className="flex gap-3 items-center">
                    <div className="fill-current text-green-600">
                        <DokanIcons icon="#logOut" />
                    </div>
                    <div className="text-tertiary hover:text-dokan-blue">
                        <button type="button">Log Out</button>
                    </div>
                </div>
            </Menu.Item>
        </Menu>
    );

    const completionMenu = (
        <Menu style={{ width: '312px', padding: '32px', marginRight: '-5px' }}>
            <div className="relative">
                <div className="flex flex-col flex-wrap items-start">
                    <div className="font-semibold text-semi-lg">Your Profile </div>
                    <div className="font-semibold text-semi-lg">
                        {`${vendor.profile_completion?.progress || 0}%`} Completed
                    </div>
                </div>
                <div className="flex items-center py-5">
                    <div className="font-semibold text-lg w-full">
                        <Progress
                            percent={75}
                            size="small"
                            strokeColor="#00C854"
                            showInfo={false}
                        />
                    </div>
                </div>
                <div className="flex flex-col justify-start items-start ">
                    {va.map((item, index) => (
                        <div className="flex space-x-3 pb-3 last:pb-0" key={index}>
                            <div className="self-end">
                                {item % 2 === 0 ? (
                                    <DokanIcons icon="#done_checked" />
                                ) : (
                                    <DokanIcons icon="#done_unchecked" />
                                )}
                            </div>
                            <div
                                className={`${item % 2 === 0 ? 'line-through' : ''} text-tertiary`}
                            >
                                Adding Banner (10%)
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Menu>
    );
    return (
        <>
            <div className="md:sticky md:top-0 md:self-start z-500">
                <header>
                    <div
                        className={`${
                            mobileSidebar
                                ? 'z-500 absolute min-h-screen bg-gray-darkest w-3/4 md:hidden'
                                : 'hidden'
                        }`}
                    >
                        {/** mobile sidebar-top */}
                        <div className="flex justify-between items-center px-5 py-3">
                            <Link to="/" className={`${isOpen ? 'block' : 'hidden'}`}>
                                <div className="flex items-center ml-15px">
                                    <DokanLogo width="32" height="32" />
                                    <h1 className="text-white text-md mx-2 ml-3 font-medium">
                                        Dokan
                                    </h1>
                                </div>
                            </Link>
                            <div>
                                <button
                                    type="button"
                                    onClick={handleMobileHeader}
                                    className="text-white"
                                >
                                    <DokanIcons icon="#open" size={4} />
                                </button>
                            </div>
                        </div>
                        {/** sidebar items */}
                        <Menu theme="dark" mode="inline" selectable={false} className="pt-20px">
                            {menuItems.map(
                                (item) =>
                                    item.sidebar && (
                                        <Menu.Item
                                            key={item.id}
                                            icon={<DokanMenuIcons icon={item.icon} size={4} />}
                                            className={`text-white flex items-center ${
                                                location.pathname === item.path
                                                    ? activeClass
                                                    : inactiveClass
                                            }`}
                                        >
                                            <NavLink
                                                exact={item.path === '/'}
                                                strict
                                                className="ml-12px"
                                                to={item.path}
                                                activeStyle={{ color: 'white' }}
                                            >
                                                {item.name}
                                            </NavLink>
                                        </Menu.Item>
                                    )
                            )}
                        </Menu>
                    </div>
                    <div className="py-3 px-6 bg-white border-b border-ash-border">
                        <div className="mx-auto flex justify-between items-center px-3 ">
                            <div className="flex flex-1">
                                {/** sidebar toggle */}
                                <div className="hidden md:block px-2">
                                    <button
                                        type="button"
                                        className="text-dark focus:outline-none"
                                        onClick={handleHeader}
                                    >
                                        {isOpen ? (
                                            <DokanIcons icon="#open" size={3} />
                                        ) : (
                                            <DokanIcons icon="#close" size={3} />
                                        )}
                                    </button>
                                </div>
                                {/** mobile sidbar toggle */}
                                <div className="block md:hidden px-2">
                                    <button
                                        type="button"
                                        className="text-dark focus:outline-none"
                                        onClick={handleMobileHeader}
                                    >
                                        <DokanIcons icon="#close" size={3} />
                                    </button>
                                </div>
                                <div className="px-2 md:hidden">
                                    <div className="flex items-center ml-15px">
                                        <DokanLogo width="32" height="32" />
                                        <h1 className="text-dark text-md mx-2 ml-3 font-medium">
                                            Dokan
                                        </h1>
                                    </div>
                                </div>
                            </div>

                            {/* right side menus */}
                            <div className="flex items-center ">
                                {location.pathname !== '/' && (
                                    <span className="form-input text-sm w-32 sm:w-64 rounded-md pl-10 pr-4 focus:border-indigo-600">
                                        <Progress
                                            percent={75}
                                            size="small"
                                            strokeColor="#00C854"
                                            showInfo={false}
                                        />
                                        <Dropdown
                                            overlay={completionMenu}
                                            placement="bottomRight"
                                            trigger={['click']}
                                            arrow
                                            overlayStyle={{
                                                marginTop: '17px',
                                                padding: '10px',
                                            }}
                                        >
                                            <button
                                                onClick={() => {}}
                                                className="mr-2 flex items-center focus:outline-none "
                                                type="button"
                                            >
                                                <span className="text-tertiary font-normal">
                                                    {`${vendor.profile_completion?.progress || 0}%`}{' '}
                                                    Completed
                                                </span>

                                                <span className="px-2">
                                                    <DokanIcons icon="#carrotDown" size={2} />
                                                </span>
                                            </button>
                                        </Dropdown>
                                    </span>
                                )}

                                {/** nofitification bell */}
                                <div>
                                    <DokanNotification />
                                </div>

                                {/* User Drop Down */}
                                <div>
                                    <Dropdown
                                        overlay={menu}
                                        placement="bottomRight"
                                        trigger={['click']}
                                        arrow
                                        overlayClassName="mt-10"
                                    >
                                        <button
                                            onClick={() => {}}
                                            className="mx-2 flex items-center focus:outline-none "
                                            type="button"
                                        >
                                            {/* user avatar */}
                                            <div className="mr-3 relative z-10 block h-10 w-10  rounded-full overflow-hidden shadow-sm focus:outline-none">
                                                <img
                                                    className="h-full w-full object-cover p-1 rounded-full"
                                                    src="https://images.unsplash.com/photo-1528892952291-009c663ce843?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=296&q=80"
                                                    alt="Your avatar"
                                                />
                                            </div>
                                            <DokanIcons icon="#carrotDown" size={2} />
                                        </button>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
        </>
    );
}

export default Header;
